document.addEventListener('alpine:init', () => {
    Alpine.data('gfSelect', () => {
        let nativeSelect = null;
        let allOptions = [];
        return {
            open: false,
            openUp: false,
            options: [],
            selected: '',
            labelPrefix: '',
            labelValue: '',
            init() {
                nativeSelect = this.$el.querySelector('select');
                if (!nativeSelect) return;
                nativeSelect.addEventListener('change', () => this._sync());
                this.$nextTick(() => {
                    this.options = Array.from(nativeSelect.options).map(o => ({ text: o.text, value: o.value }));
                    allOptions = [...this.options];
                    this._sync();
                    this._initSeatings();
                });
            },
            _sync() {
                this.selected = nativeSelect ? nativeSelect.value : '';
                const opt = this.options.find(o => o.value === this.selected);
                const gfLabel = this.$el.dataset.gfLabel;
                if (opt?.value && gfLabel) {
                    this.labelPrefix = gfLabel + ': ';
                    this.labelValue  = opt.text;
                } else {
                    this.labelPrefix = '';
                    this.labelValue  = opt ? opt.text : '';
                }
            },
            _initSeatings() {
                if (!this.$el.closest('.gfield--conference-seatings')) return;
                const roomSelect = document.querySelector('.gfield--conference-rooms .ginput_container_select select');
                if (roomSelect?.value) {
                    this._filterBySeatings(roomSelect.value);
                }
                document.addEventListener('gf:conference-rooms-change', (e) => {
                    this._filterBySeatings(e.detail.roomId);
                });
            },
            _filterBySeatings(roomId) {
                if (!roomId || !window.gfRoomSeatings) {
                    this.options = [...allOptions];
                    if (nativeSelect) nativeSelect.value = '';
                } else {
                    const available = window.gfRoomSeatings[roomId] || [];
                    this.options = allOptions.filter(o => !o.value || available.includes(o.value));
                    if (nativeSelect && !this.options.find(o => o.value === nativeSelect.value)) {
                        nativeSelect.value = '';
                    }
                }
                this._sync();
            },
            toggle() {
                if (!this.open) {
                    const rect = this.$el.getBoundingClientRect();
                    this.openUp = (window.innerHeight - rect.bottom) < 240;
                }
                this.open = !this.open;
            },
            choose(opt) {
                if (nativeSelect) {
                    nativeSelect.value = opt.value;
                    nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (this.$el.closest('.gfield--conference-rooms')) {
                    document.dispatchEvent(new CustomEvent('gf:conference-rooms-change', { detail: { roomId: opt.value } }));
                }
                this.open = false;
            },
        };
    });

    Alpine.data('gfChoices', () => ({
        open: false,
        openUp: false,
        labelPrefix: '',
        labelValue: '',
        init() {
            this.$nextTick(() => {
                this._bindInputs();
                this._updateLabel();
            });
        },
        _bindInputs() {
            const isRadio = !!this.$el.querySelector('input[type="radio"]');
            this.$el.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
                input.addEventListener('change', () => {
                    this._updateLabel();
                    if (isRadio) this.open = false;
                });
            });
        },
        _updateLabel() {
            const checked = Array.from(this.$el.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'));
            const gfLabel = this.$el.dataset.gfLabel || '';
            if (!checked.length) {
                this.labelPrefix = '';
                this.labelValue  = gfLabel;
                return;
            }
            const values = checked.map(i => {
                const lbl = this.$el.querySelector(`label[for="${i.id}"]`);
                return lbl ? lbl.textContent.trim() : i.value;
            });
            const rest = values.length - 1;
            this.labelPrefix = gfLabel ? gfLabel + ': ' : '';
            this.labelValue  = values[0] + (rest ? ', +' + rest : '');
        },
        toggle() {
            if (!this.open) {
                const rect = this.$el.getBoundingClientRect();
                this.openUp = (window.innerHeight - rect.bottom) < 240;
            }
            this.open = !this.open;
        },
    }));

    setupGFSelects(document);
});

document.addEventListener('gform_post_render', function () {
    document.querySelectorAll('.gform_wrapper .ginput_container_select:not([data-gf-custom-select])').forEach(container => {
        if (setupGFSelectContainer(container)) Alpine.initTree(container);
    });
    ['checkbox', 'radio'].forEach(type => {
        document.querySelectorAll(`.gform_wrapper .ginput_container_${type}:not([data-gf-custom-choices])`).forEach(container => {
            if (setupGFChoicesContainer(container)) Alpine.initTree(container);
        });
    });
});

function setupGFSelects(root) {
    root.querySelectorAll('.gform_wrapper .ginput_container_select:not([data-gf-custom-select])').forEach(container => {
        setupGFSelectContainer(container);
    });
    ['checkbox', 'radio'].forEach(type => {
        root.querySelectorAll(`.gform_wrapper .ginput_container_${type}:not([data-gf-custom-choices])`).forEach(container => {
            setupGFChoicesContainer(container);
        });
    });
}

function readGFLabel(container) {
    const gfield = container.closest('.gfield');
    const labelEl = gfield ? gfield.querySelector('.gfield_label') : null;
    if (!labelEl) return;
    const clone = labelEl.cloneNode(true);
    clone.querySelectorAll('.gfield_required').forEach(el => el.remove());
    container.dataset.gfLabel = clone.textContent.trim();
}

function makeGFDropdownBtn() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gf-select-btn';
    btn.setAttribute('@click', 'toggle()');
    btn.setAttribute('@keydown.escape', 'open = false');
    btn.setAttribute(':aria-expanded', 'open.toString()');
    btn.innerHTML = '<span class="min-w-0 truncate flex"><span class="font-medium shrink-0" x-show="labelPrefix" x-text="labelPrefix"></span><span class="min-w-0 truncate" :class="labelPrefix ? \'font-normal\' : \'font-medium\'" x-text="labelValue"></span></span><i class="icon-angle transition-transform duration-200 shrink-0" :class="open ? \'rotate-180\' : \'\'"></i>';
    return btn;
}

function setupGFChoicesContainer(container) {
    const choicesEl = container.querySelector('.gfield_checkbox, .gfield_radio');
    if (!choicesEl) return false;

    container.dataset.gfCustomChoices = '1';
    container.setAttribute('x-data', 'gfChoices');
    readGFLabel(container);

    const dropdown = document.createElement('div');
    dropdown.className = 'gf-select-list gf-choices-list';
    dropdown.setAttribute('x-show', 'open');
    dropdown.setAttribute('x-cloak', '');
    dropdown.setAttribute('@click.outside', 'open = false');
    dropdown.setAttribute(':class', "{ 'open-up': openUp }");
    dropdown.appendChild(choicesEl);

    container.appendChild(makeGFDropdownBtn());
    container.appendChild(dropdown);
    return true;
}

function setupGFSelectContainer(container) {
    const select = container.querySelector('select');
    if (!select) return false;

    container.dataset.gfCustomSelect = '1';
    container.setAttribute('x-data', 'gfSelect');
    select.classList.add('sr-only');
    readGFLabel(container);
    if (container.dataset.gfLabel) {
        select.setAttribute('aria-label', container.dataset.gfLabel);
    }

    const list = document.createElement('ul');
    list.className = 'gf-select-list';
    list.setAttribute('x-show', 'open');
    list.setAttribute('x-cloak', '');
    list.setAttribute('@click.outside', 'open = false');
    list.setAttribute(':class', "{ 'open-up': openUp }");
    list.innerHTML = '<template x-for="opt in options" :key="opt.value"><li @click="choose(opt)" :class="{ \'is-selected\': opt.value === selected }" x-text="opt.text"></li></template>';

    container.appendChild(makeGFDropdownBtn());
    container.appendChild(list);
    return true;
}

// Gravity Forms' datepicker (Apex4X-based, not jQuery UI -- confirmed empirically,
// see lighthouse-playbook.md). It dispatches a plain "change" event on the input
// after a date is picked, so a delegated change listener is all that's needed.
document.addEventListener('DOMContentLoaded', function () {
    if (window.gform) {
        gform.addFilter('gform_datepicker_options_pre_init', function (options) {
            options.minDate = 0; // 0 = today; blocks past dates
            return options;
        });
    }

    const GF_DATE_FORMATS = {
        ymd_dash:  { order: ['y', 'm', 'd'], sep: '-' },
        ymd_dot:   { order: ['y', 'm', 'd'], sep: '.' },
        ymd_slash: { order: ['y', 'm', 'd'], sep: '/' },
        dmy_dash:  { order: ['d', 'm', 'y'], sep: '-' },
        dmy_dot:   { order: ['d', 'm', 'y'], sep: '.' },
        dmy:       { order: ['d', 'm', 'y'], sep: '/' },
        mdy:       { order: ['m', 'd', 'y'], sep: '/' },
    };

    function gfDateFormat(input) {
        const key = Object.keys(GF_DATE_FORMATS).find((k) => input.classList.contains(k));
        return GF_DATE_FORMATS[key] || GF_DATE_FORMATS.mdy;
    }

    function parseGfDate(input) {
        const fmt = gfDateFormat(input);
        const parts = (input.value || '').split(fmt.sep);
        if (parts.length !== 3) return null;
        const value = {};
        fmt.order.forEach((unit, i) => { value[unit] = parseInt(parts[i], 10); });
        if (!value.y || !value.m || !value.d) return null;
        const date = new Date(value.y, value.m - 1, value.d);
        return isNaN(date.getTime()) ? null : date;
    }

    function formatGfDate(date, input) {
        const fmt = gfDateFormat(input);
        const parts = {
            y: date.getFullYear(),
            m: String(date.getMonth() + 1).padStart(2, '0'),
            d: String(date.getDate()).padStart(2, '0'),
        };
        return fmt.order.map((unit) => parts[unit]).join(fmt.sep);
    }

    // When the start date changes, push the end date forward a day if it's
    // now missing or no longer after the start date.
    document.addEventListener('change', function (e) {
        if (!e.target.matches?.('.gfield--start-date input.gform-datepicker')) return;
        const end = document.querySelector('.gfield--end-date input.gform-datepicker');
        if (!end) return;
        const start = parseGfDate(e.target);
        if (!start) return;
        const endDate = parseGfDate(end);
        if (endDate && endDate > start) return;
        const next = new Date(start);
        next.setDate(next.getDate() + 1);
        end.value = formatGfDate(next, end);
        end.dispatchEvent(new Event('change', { bubbles: true }));
    });
});

//# sourceMappingURL=forms.js.map
